export default "__VITE_ASSET__31cc2d3e__"